import { TCreateUserReqDto, TCreateUserResDto } from "@/api/services/admin/user/dtos/create-user.dto";
import { TForceChangePasswordReqDto, TForceChangePasswordResDto } from "@/api/services/admin/user/dtos/force-change-password.dto";
import { TGetUserDetailResDto } from "@/api/services/admin/user/dtos/get-user-detail.dto";
import { TUpdateUserReqDto, TUpdateUserResDto } from "@/api/services/admin/user/dtos/update-user.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const createUserApi = async (payload: TCreateUserReqDto): Promise<TCreateUserResDto> => {
  const rs = await clientApi.post<TCreateUserResDto>("/users", payload);
  return rs.data;
};

export const fetchUserDetailApi = async (userId: string): Promise<TGetUserDetailResDto> => {
  const rs = await clientApi.get<TGetUserDetailResDto>(`/users/${userId}`);
  return rs.data;
};

export const useUserDetail = () => {
  const { userId } = useParams();
  return useQuery({
    queryKey: [QUERY_KEYS.ORGANIZATION_USER.FETCH_DETAIL, userId],
    queryFn: () => (userId ? fetchUserDetailApi(userId) : undefined),
    enabled: Boolean(userId),
  });
};

export const forceChangePasswordApi = async (payload: TForceChangePasswordReqDto): Promise<TForceChangePasswordResDto> => {
  const rs = await clientApi.post<TForceChangePasswordResDto>("/users/force-change-password", payload);
  return rs.data;
};

export const useForceChangePassword = () => {
  return useMutation({
    mutationFn: (payload: TForceChangePasswordReqDto) => forceChangePasswordApi(payload),
  });
};

export const updateUserApi = async (id: number, payload: TUpdateUserReqDto): Promise<TUpdateUserResDto> => {
  const rs = await clientApi.put<TUpdateUserResDto>(`/users/${id}`, payload);
  return rs.data;
};

export const resendUserInvitationApi = async (id: number): Promise<{ data: true }> => {
  const rs = await clientApi.post<{ data: true }>(`/users/${id}/resend-invitation`);
  return rs.data;
};

export const useResendUserInvitation = () => {
  return useMutation({
    mutationFn: (id: number) => resendUserInvitationApi(id),
  });
};
